import React from 'react';
import { useAuth } from '../../contexts/AuthContext.tsx';
import { AppIcon } from '../../icons/appIcons.tsx';

export default function ImpersonationBanner() {
  const { impersonation, stopImpersonation, user } = useAuth();
  const [returning, setReturning] = React.useState(false);

  if (!impersonation?.isImpersonating) {
    return null;
  }

  const handleReturn = async () => {
    setReturning(true);
    const success = await stopImpersonation();
    if (success) {
      // Redirect to admin dashboard
      window.location.href = '/admin';
    } else {
      setReturning(false);
      alert('Failed to return to admin account. Please try again.');
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-yellow-500 to-orange-500 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <AppIcon name="impersonate" className="w-7 h-7 shrink-0" />
          <div>
            <p className="font-semibold">
              Impersonating: {user?.firstName} {user?.lastName} ({user?.email})
            </p>
            <p className="text-xs text-white/90">
              Original admin: {impersonation.adminEmail}
            </p>
          </div>
        </div>
        <button
          onClick={handleReturn}
          disabled={returning}
          className="px-4 py-2 bg-white text-orange-600 rounded-lg hover:bg-gray-100 font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {returning ? 'Returning...' : '← Return to Admin'}
        </button>
      </div>
    </div>
  );
}

